import type { JSX } from "react";

export const useBrandNavigation = (
  getStepForm: (stepId: number) => JSX.Element,
  router?: { getCurrentStep: () => number }
) => {
  const names = ["Details", "Menu", "Contacts", "Branches"];

  // Get current step from router (which extracts from pathname)
  const currentStep = router?.getCurrentStep() ?? 1;
  const activeId = currentStep >= 1 && currentStep <= 4 ? currentStep : 1;

  const stepsBase = Array.from({ length: 4 }, (_, i) => ({
    id: i + 1,
    name: names[i],
    form: getStepForm(i + 1),
  }));

  // Generate navigation list based on active step
  const navigationList = stepsBase.map(step => ({
    ...step,
    done: step.id < activeId,
    active: step.id === activeId,
  }));

  const activeStep = navigationList.find(step => step.active);

  return { navigationList, activeStep, activeId };
};
